import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import SEO from '@nubank/www-latam-commons/components/SEO/SEO';

import routes from '../../pages/routes.json';
import {
  domain, images, baseBreadcrumb, corporateContactData,
} from '../../utils/seo';

const ContractPageSEO = ({ routeKey, data }) => {
  const intl = useIntl();
  const { title, description, headSeoBreadcrumbTitle } = data;

  const routeData = routes[routeKey] || {};
  const {
    noindex,
    nofollow,
    canonicals = {},
    alternate,
  } = routeData;

  const canonicalPage = canonicals[intl.locale];

  return (
    <SEO
      pageTitle={title}
      description={description}
      noindex={noindex}
      nofollow={nofollow}
      canonicalPage={canonicalPage}
      alternatePages={alternate}
      breadcrumbTitle={headSeoBreadcrumbTitle}
      domain={domain}
      images={images}
      baseBreadcrumb={baseBreadcrumb}
      corporateContactData={corporateContactData}
      siteName="Nubank"
    />
  );
};

ContractPageSEO.propTypes = {
  data: PropTypes.shape({
    description: PropTypes.string,
    headSeoBreadcrumbTitle: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  routeKey: PropTypes.string.isRequired,
};

export default ContractPageSEO;
